import { camelCase, startCase, trim } from 'lodash-es';

type ElectronicSigningOptions = {
  hasZillowPayments: boolean;
  otherElectronicPaymentOptions: string;
};

export const ZILLOW_PAYMENTS_STRING = 'Zillow Payments';

export function parseElectronicPaymentOptions(rawOptionsString: string): ElectronicSigningOptions {
  const zillowStringPermutations = rawOptionsString.match(/(,?\s*Zillow Payments)/g) || [];
  let otherElectronicPaymentOptions = rawOptionsString;
  zillowStringPermutations.forEach((permutation: string) => {
    otherElectronicPaymentOptions = otherElectronicPaymentOptions.replace(permutation, '');
  });
  otherElectronicPaymentOptions = trim(otherElectronicPaymentOptions, ' ,');

  return {
    hasZillowPayments: zillowStringPermutations.length > 0,
    otherElectronicPaymentOptions,
  };
}

export function hyphenateString(rawString: string): string {
  return rawString
    .replace(/[^a-zA-Z_0-9]/gi, ' ')
    .trim()
    .replace(/\s+/gi, '-')
    .toLocaleLowerCase();
}

export function getTitleCase(input: string): string {
  return startCase(camelCase(input));
}
